// Do not edit.
import { ShaderStore } from "../../Engines/shaderStore";

const name = "geometryUboDeclaration";
const shader = `#include<sceneUboDeclaration>
`;
// Sideeffect
if (!ShaderStore.IncludesShadersStore[name]) {
    ShaderStore.IncludesShadersStore[name] = shader;
}
ShaderStore._PendingIncludesLoaders.push(() => Promise.all([
    import("./sceneUboDeclaration")
]));
/** @internal */
export const geometryUboDeclaration = { name, shader };
